import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isControlInvalidAndTouched',
  standalone: false
})
export class IsControlInvalidAndTouchedPipe implements PipeTransform {
  transform(
    formControlTouched?: boolean,
    formControlInvalid?: boolean
  ): boolean {
    return !!(formControlInvalid && formControlTouched);
  }
}
